import React from 'react'
import useFormValidation from "../../components/auth/useFormValidation";

import FirebaseContext from "../../firebase/context";

import { Button, TextField, TableRow, TableCell, Grid, Paper } from '@material-ui/core';
import SaveIcon from '@material-ui/icons/Save';
import CancelIcon from '@material-ui/icons/Cancel';

import CompAdminExamenItem from './CompAdminExamenItem';
import validateCreateExamen from '../../components/auth/validateCreateExamen';

const style = {
    paper: {
        backgroundColor: "#f5f5f5",
        padding: "20px",
        minHeight: 650
    },
    gridTextfield: {
        marginTop: "20px"
    }
};

const CompAdminExamenAdd = (props) => {
    const { firebase } = React.useContext(FirebaseContext);
    const [examen, setExamen] = React.useState({       
        aTituloExamen: "",
        bFechaExamen: "",
        bUrlExamen: "",
        bPuntajeTotal: "",       
        cEstado: "",
        cRespuestas: [],
        dPuntajes: [],
        eAlumnos: [],
    })
    const INITIAL_STATE = {
        tituloExamen: "",
        fechaExamen: "",
        bUrlExamen: "",
    };
    const { handleSubmit, handleChange, values, errors } = useFormValidation(
        INITIAL_STATE,
        validateCreateExamen,
        handleCreateExamen
    );

    function handleCreateExamen() {
        const {tituloExamen, fechaExamen, urlExamen} = values;
        let total = 0
        examen.dPuntajes.forEach((a) => { total += a })

        let newObjectDB = { ...examen }       
        newObjectDB.aTituloExamen = tituloExamen;
        newObjectDB.bFechaExamen = fechaExamen;
        newObjectDB.bUrlExamen = urlExamen;
        newObjectDB.bPuntajeTotal = total;
        newObjectDB.cEstado = 1;
        setExamen(newObjectDB);
       
        firebase.db.collection("colExamenes").add(newObjectDB);
        props.setShowExamenAdd(false);
    }

    const preguntaAdd = () => {
        let newObject = { ...examen }
        console.log("newObject");
        console.log(newObject);

        newObject.cRespuestas.push("")
        newObject.dPuntajes.push(2)
        setExamen(newObject)
    }



    return (
        <React.Fragment>
            <TableRow >
                <TableCell align='justify'>
                <form onSubmit={handleSubmit} >
                <TextField
                            fullWidth
                            variant="outlined"
                            label="Titulo de Examen"
                            name="tituloExamen"
                            margin="normal"
                            placeholder="Titulo de Examen"
                            autoComplete="off"
                            type="text"
                            onChange={handleChange}
                            className={errors.tituloExamen && "error-input"}
                            value={values.tituloExamen}
                        />
                        {errors.tituloExamen && <p className="error-text">{errors.tituloExamen}</p>}
                        <TextField
                            fullWidth
                            variant="outlined"
                            label="Fecha de Examen"
                            name="fechaExamen"
                            margin="normal"
                            placeholder="Fecha de Examen"
                            autoComplete="off"
                            type="text"
                            onChange={handleChange}
                            className={errors.fechaExamen && "error-input"}
                            value={values.fechaExamen}
                        />
                        {errors.fechaExamen && <p className="error-text">{errors.fechaExamen}</p>}
                        <TextField
                            fullWidth
                            variant="outlined"
                            label="Url de Examen"
                            name="urlExamen"
                            margin="normal"
                            placeholder="Url de Examen"
                            autoComplete="off"
                            type="text"
                            onChange={handleChange}
                            className={errors.urlExamen && "error-input"}
                            value={values.urlExamen}
                        />
                        {errors.urlExamen && <p className="error-text">{errors.urlExamen}</p>}
                    <Button
                        variant="contained"
                        color="secondary"
                        size="small"
                        className="button"
                        type="button"
                        startIcon={<SaveIcon />}
                        onClick={() => preguntaAdd()}
                    >
                        Adicionar
                        </Button>
                        <Button
                            variant="contained"
                            color="secondary"
                            size="small"
                            className="button"
                            type="submit"
                            startIcon={<SaveIcon />}
                        >
                            GUARDAR
                               </Button>
                    {/* <Button
                        variant="contained"
                        color="secondary"
                        size="small"
                        className="button"
                        type="button"
                        startIcon={<SaveIcon />}
                        onClick={() => preguntaSave()}
                    >
                        Guardar
                        </Button> */}
                    <Button
                        variant="contained"
                        color="secondary"
                        size="small"
                        type="button"
                        onClick={() => props.setShowExamenAdd(false)}
                        startIcon={<CancelIcon />}
                    >
                        CANCELAR
                        </Button>

                    <Grid item xs={12} sm={6} style={style.gridTextfield}>
                        <Paper style={style.paper}>
                            <Grid container spacing={1}>
                                {examen.cRespuestas.map((respuesta, index) => (
                                    <CompAdminExamenItem
                                        key={index}
                                        respuesta={respuesta}
                                        setExamen={setExamen}
                                        examen={examen}
                                        index={index + 1}
                                    />
                                ))}
                            </Grid>

                        </Paper>
                    </Grid>

                    </form>

                </TableCell>
            </TableRow>
        </React.Fragment>
    );
}

export default CompAdminExamenAdd
